import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LabelCheckbox from '../../../../components/LabelCheckbox';
import { substituteForPreview } from '../../utils/composeBodyPreview';
import SectionCard from '../../components/SectionCard';
import PreviewText from '../../components/PreviewText';
import PreviewImage from '../../components/PreviewImage';
import texts from '../../texts.json';

const PreviewCard = ({ body, coachName, imageUrl }) => {
  const [withImage, setWithImage] = useState(true);

  const headerActions = imageUrl ? (
    <LabelCheckbox
      isChecked={withImage}
      onChange={setWithImage}
      description={texts.sidePanel.previewWithImage}
    />
  ) : null;

  return (
    <SectionCard title={texts.sidePanel.previewLabel} action={headerActions}>
      {imageUrl && withImage && <PreviewImage src={imageUrl} />}
      <PreviewText>{substituteForPreview(body, { coachName })}</PreviewText>
    </SectionCard>
  );
};

PreviewCard.propTypes = {
  body: PropTypes.string.isRequired,
  coachName: PropTypes.string,
  imageUrl: PropTypes.string,
};

PreviewCard.defaultProps = {
  coachName: '',
  imageUrl: '',
};

export default PreviewCard;
